import { useState, useEffect } from "react";
import axios from "axios";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2, Check, X, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";

const API = (process.env.REACT_APP_BACKEND_URL || "https://bvglinkamazon.com") + "/api";

export const AdminWalletRequests = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const token = localStorage.getItem('admin_token');
            const res = await axios.get(`${API}/admin/bvgpay/topups`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setRequests(res.data);
        } catch (error) {
            toast.error("Pa ka chaje demann yo");
        } finally {
            setLoading(false);
        }
    };

    const handleAction = async (id, status, requestedAmount) => {
        let finalAmount = null;
        if (status === 'approved') {
            const confirmedAmountStr = window.prompt(
                `POU SEKIRITE BOUS LA: Konbyen kòb OU MENM ou deside alwe pou demann sa a kounye a?\n\n(Kliyan an te mande: ${requestedAmount} HTG)`, 
                requestedAmount
            );
            if (confirmedAmountStr === null) return; // cancelled
            finalAmount = parseFloat(confirmedAmountStr);
            if (isNaN(finalAmount) || finalAmount <= 0) {
                toast.error("Montan sa a pa sanble bon!");
                return;
            }
        } else {
            if (!window.confirm(`Èske ou sèten ou vle mèt demann sa a ${status}?`)) return;
        }

        try {
            const token = localStorage.getItem('admin_token');
            await axios.post(`${API}/admin/bvgpay/topups/${id}/action`, { 
                status, 
                approved_amount: finalAmount 
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success(`Demann lan ${status} avek siksè`);
            fetchRequests();
        } catch (error) {
            toast.error("Echèk nan aktyalize demann lan");
        }
    };

    return (
        <AdminLayout>
            <div className="space-y-6">
                <div className="flex justify-between items-center bg-indigo-900 text-white p-6 rounded-2xl shadow-xl">
                    <div>
                        <h1 className="text-3xl font-black italic tracking-tighter uppercase">Demann Rechaj BVGPAY</h1>
                        <p className="opacity-80">Apwouve oswa Rejte demann rechaj bous Kliyan yo</p>
                    </div>
                </div>

                {loading ? (
                    <div className="flex justify-center p-12">
                        <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
                    </div>
                ) : (
                    <div className="grid gap-6">
                        {requests.map((req) => (
                            <Card key={req.id} className="border-t-4 border-t-indigo-500 shadow-sm hover:shadow-md transition-all">
                                <CardContent className="p-6 flex flex-col md:flex-row gap-6 items-center justify-between">
                                    <div className="space-y-2 flex-1">
                                        <div className="flex items-center gap-3">
                                            <span className={`px-3 py-1 rounded-full text-xs font-black uppercase tracking-widest ${
                                                req.status === 'pending' ? 'bg-orange-100 text-orange-700' :
                                                req.status === 'approved' ? 'bg-green-100 text-green-700' :
                                                'bg-red-100 text-red-700'
                                            }`}>
                                                {req.status}
                                            </span>
                                            <span className="text-sm text-gray-500 font-bold">{new Date(req.created_at).toLocaleString()}</span>
                                        </div>
                                        <h3 className="text-2xl font-black italic tracking-tighter">{req.amount_htg.toLocaleString()} HTG</h3>
                                        <div className="text-sm font-medium text-gray-600 space-y-1">
                                            <p>Kliyan ID: <span className="text-indigo-600 cursor-copy" title={req.buyer_id}>{req.buyer_id.substring(0,8)}...</span></p>
                                            <p>Imèl/Tel: <span className="font-bold">{req.email || req.phone || "N/A"}</span></p>
                                            <p className="uppercase tracking-widest text-xs pt-2">Mwayen: <span className="text-indigo-600 font-black">{req.method.replace('_', ' ')}</span></p>
                                            <p className="uppercase tracking-widest text-xs">Ref: <span className="font-black">{req.reference_id}</span></p>
                                        </div>
                                    </div>
                                    
                                    <div className="flex flex-col gap-3 min-w-[200px]">
                                        {req.proof_image && (
                                            <Button variant="outline" className="w-full font-bold uppercase tracking-widest text-xs" onClick={() => setSelectedImage(req.proof_image)}>
                                                <Eye className="w-4 h-4 mr-2" /> Wè Prèv La
                                            </Button>
                                        )}
                                        {req.status === 'pending' && (
                                            <div className="flex gap-2">
                                                <Button className="flex-1 bg-green-600 hover:bg-green-700 font-black uppercase" onClick={() => handleAction(req.id, 'approved', req.amount_htg)}>
                                                    <Check className="w-4 h-4 mr-1" /> Apwouve
                                                </Button>
                                                <Button className="flex-1 bg-red-600 hover:bg-red-700 font-black uppercase" onClick={() => handleAction(req.id, 'rejected')}>
                                                    <X className="w-4 h-4 mr-1" /> Rejete
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </CardContent>
                            </Card>
                        ))}
                        {requests.length === 0 && (
                            <div className="text-center py-20 text-gray-400 font-black italic tracking-widest uppercase">
                                Pa gen okenn demann rechaj ki anrejistre
                            </div>
                        )}
                    </div>
                )}
            </div>

            <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
                <DialogContent className="max-w-3xl">
                    <DialogHeader>
                        <DialogTitle>Prèv Peman An</DialogTitle>
                    </DialogHeader>
                    {selectedImage && (
                        <div className="flex justify-center p-4">
                            <img src={selectedImage} alt="Prèv Peman" className="max-w-full max-h-[70vh] rounded-xl shadow-lg object-contain" />
                        </div>
                    )}
                </DialogContent>
            </Dialog>
        </AdminLayout>
    );
};
